var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between items-center text-xl20 font-semibold mt-3"},[_c('div',[_vm._v(_vm._s(_vm.spec.key))]),_c('div',{staticClass:"text-text-body"},[_vm._v(_vm._s(_vm.spec.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }